module.exports = __webpack_public_path__ + "static/media/logo--chrome.37df5220.svg";